import React, { useState } from 'react';
import './Addvideo.css';
import Select from "react-select";
import { ToastContainer, toast } from 'react-toastify';
import { AddVideoApi } from '../../Services/allApi';
import { Navigate, useNavigate } from 'react-router-dom';

function AddVideo() {
    const navigate = useNavigate();
    const sessionoptions = [
        { value: 1, label: "Session 1" },
        { value: 2, label: "Session 2" },
        { value: 3, label: "Session 3" },
        { value: 23, label: "Session 4" }
    ];

    const klaoptions = [
        { value: 1, label: "KLA 1" },
        { value: 2, label: "KLA 2" },
        { value: 3, label: "KLA 3" },
        { value: 16, label: "KLA 4" }
    ];
    const eventoptions = [
        { value: 1, label: "Event 1" },
        { value: 2, label: "Event 2" },
        { value: 3, label: "Event 3" },
        { value: 38, label: "Event 4" }
    ];

    const memberoptions = [
        { value: 1, label: "Member 1" },
        { value: 2, label: "Member 2" },
        { value: 3, label: "Member 3" },
        { value: 4, label: "Member 4" }
    ];

    const [isFormOpen, setIsFormOpen] = useState(false);
    const [tags, setTags] = useState({});
    const [tagCount, setTagCount] = useState(1);
    const [numberOfVideos, setNumberOfVideos] = useState('');
    const [videoDetailsArray, setVideoDetailsArray] = useState([]);

    function Tag(key, value) {
        this.key = key;
        this.value = value;
    }

    const [keyFromInput, setKeyFromInput] = useState('');
    const [valueFromInput, setValueFromInput] = useState('');

    const handleKeyInput = (e) => {
        setKeyFromInput(e);
    };

    const handleValueInput = (e) => {
        setValueFromInput(e);
    };

    const handleTagAdd = (index) => {
        if (keyFromInput && valueFromInput) {
            const newTag = new Tag(`${keyFromInput}`, `${valueFromInput}`);
            setVideoDetailsArray(prevDetails => {
                const updatedDetails = [...prevDetails];
                updatedDetails[index].video_tags = {
                    ...updatedDetails[index].video_tags,
                    [`tag${tagCount}`]: newTag
                };
                return updatedDetails;
            });
            setTagCount(prevCount => prevCount + 1);
            setKeyFromInput('');
            setValueFromInput('');
        } else {
            toast.warning("Please enter tag as key value pair");
        }
    };

    const handleRemoveTag = (index, key) => {
        setVideoDetailsArray(prevDetails => {
            const updatedDetails = [...prevDetails];
            const newTags = { ...updatedDetails[index].video_tags };
            delete newTags[key];
            updatedDetails[index].video_tags = newTags;
            return updatedDetails;
        });
    };

    const [VideoInitialDetails, setVideoInitialDetails] = useState({
        video_upload_date: '',
        kla: {},
        video_session: {},
        numberOfVideos: ''
    });

    const handleSubmitInitialDetails = () => {
        console.log(VideoInitialDetails);
        if (
            // VideoInitialDetails.kla &&
            VideoInitialDetails.kla.value  &&
            // VideoInitialDetails.video_session &&
            VideoInitialDetails.video_session.value &&
            VideoInitialDetails.video_upload_date &&
            VideoInitialDetails.numberOfVideos
        ) {
            const videos = [];
            for (let i = 0; i < parseInt(VideoInitialDetails.numberOfVideos); i++) {
                videos.push({
                    video_url: '',
                    video_sequence_no: '',
                    video_title: '',
                    video_subject: '',
                    video_upload_date: VideoInitialDetails.video_upload_date,
                    kla: VideoInitialDetails.kla,
                    video_session: VideoInitialDetails.video_session,
                    video_event: '',
                    video_member: [],
                    video_tags: {},
                    numberOfVideos: VideoInitialDetails.numberOfVideos
                });
            }
            setVideoDetailsArray(videos);
            setIsFormOpen(true);
        } else {
            toast.warning('Please select KLA and session');
        }
    };
    

    const handleSave = async () => {
        const updatedTags = {};
        Object.entries(tags).forEach(([tagName, tag]) => {
            updatedTags[tag.key] = tag.value;
        });
        setVideoDetailsArray(prevDetails => {
            return prevDetails.map(video => ({
                ...video,
                video_tags: updatedTags
            }));
        });
        const token = sessionStorage.getItem('access_token');
        const reqHeader = {
            "Content-Type": "application/json",
            "Authorization": `${token}`
        };
        console.log(videoDetailsArray);
        const isFormFilled = videoDetailsArray.every(video => (
            video.video_url && video.video_sequence_no && video.video_title && 
            video.video_subject && video.video_upload_date && video.kla && 
            video.video_session && video.video_event!='' && video.video_member!=''
        ));
        
        if (isFormFilled) {
            // Perform save operation
            // const res = await AddVideoApi(videoDetailsArray, reqHeader);
            // if (res.status === 200) {
            //     toast.success("Video added successfully");
            // }
            toast.success('Videos added successfully');
        } else {
            toast.warning("Please fill all the fields in the forms");
        }
    };

    const handleCancel = () => {
        setVideoInitialDetails({
            video_upload_date: '',
            kla: {},
            video_session: {},
            numberOfVideos: ''
        });
        setIsFormOpen(false);
        setVideoDetailsArray([]);
    };

    return (
        <>
            {!isFormOpen &&
                <div className='w-full h-full items-center flex-col flex justify-center' style={{ fontFamily: 'ropa sans' }}>
                    <div className='w-9/12 flex flex-col'>
                        <div className='flex justify-center '><h2 className='mt-12 md:text-xl text-md'>Enter common details</h2></div>
                        <div className='flex flex-row justify-between flex-wrap'>
                            <div className='mt-6 flex flex-col md:w-5/12 w-full'>
                                <label htmlFor="kla">KLA</label>
                                <Select
                                    id='kla'
                                    options={klaoptions}
                                    value={klaoptions.find(option => option.value === VideoInitialDetails.kla)}
                                    onChange={option => setVideoInitialDetails({ ...VideoInitialDetails, kla: option })}
                                    styles={{
                                        control: (baseStyles, state) => ({
                                            ...baseStyles,
                                            borderColor: state.isFocused ? '#384D6C' : '#384D6C',
                                            height: '3rem',
                                            borderRadius: '0.5rem',

                                        }),
                                    }}
                                />
                            </div>
                            <div className='mt-6 flex flex-col md:w-5/12 w-full'>
                                <label htmlFor="session">Session</label>
                                <Select
                                    id='session'
                                    options={sessionoptions}
                                    value={sessionoptions.find(option => option.value === VideoInitialDetails.video_session)}
                                    onChange={option => setVideoInitialDetails({ ...VideoInitialDetails, video_session: option })}
                                    styles={{
                                        control: (baseStyles, state) => ({
                                            ...baseStyles,
                                            borderColor: state.isFocused ? '#384D6C' : '#384D6C',
                                            height: '3rem',
                                            borderRadius: '0.5rem',

                                        }),
                                    }}
                                />
                            </div>
                        </div>
                        <div className='flex flex-row justify-between flex-wrap'>
                            <div className='mt-6 flex flex-col md:w-5/12 w-full'>
                                <label htmlFor="date">Date</label>
                                <input
                                    value={VideoInitialDetails.video_upload_date}
                                    onChange={(e) => setVideoInitialDetails({ ...VideoInitialDetails, video_upload_date: e.target.value })}
                                    type="date"
                                    className='dateinput w-fll h-12 rounded-lg'
                                    style={{ border: '1px solid #384D6C' }} 
                                />
                            </div>
                            <div className='mt-6 flex flex-col md:w-5/12 w-full'>
                                <label htmlFor="number">Number of Videos</label>
                                <input
                                    value={VideoInitialDetails.numberOfVideos}
                                    onChange={(e) => setVideoInitialDetails({ ...VideoInitialDetails, numberOfVideos: e.target.value })}
                                    type="number"
                                    min="1"
                                    className='dateinput w-fll h-12 rounded-lg'
                                    style={{ border: '1px solid #384D6C' }} 
                                />
                            </div>
                        </div>
                        <div className='flex justify-center'>
                            <button onClick={handleSubmitInitialDetails} className='focus:outline-none bg-black text-white font-bold py-2 px-6 rounded-lg mt-6'>Submit</button>
                        </div>
                    </div>
                </div>
            }

            {isFormOpen &&
                <>
                   <div className='w-full h-full items-center flex-col flex justify-center' style={{ fontFamily: 'ropa sans' }}>
                   {videoDetailsArray.map((video, index) => (
                        <div key={index} className='border-2 border-blue-500 rounded mt-10 mb-10 p-5 w-10/12 h-full items-center flex-col flex justify-center' style={{ fontFamily: 'ropa sans' }}>
                            <div className='w-9/12 flex flex-col'>
                                <div className='flex justify-center '><h2 className='mt-12 md:text-xl text-md'>Enter Video {index + 1} details</h2></div>

                                 {/* row1 */}
                                <div className='flex flex-row justify-between flex-wrap'>
                                    <div className='mt-6 flex flex-col md:w-5/12 w-full'>
                                        <label htmlFor="url">URL</label>
                                        <input
                                            value={video.video_url}
                                            onChange={(e) => setVideoDetailsArray(prevDetails => {
                                                const updatedDetails = [...prevDetails];
                                                updatedDetails[index].video_url = e.target.value;
                                                return updatedDetails;
                                            })}
                                            type="text"
                                            className='dateinput w-fll h-12 rounded-lg'
                                            style={{ border: '1px solid #384D6C' }} 

                                        />
                                    </div>

                                    <div className='mt-6 flex flex-col md:w-5/12 w-full'>
                                        <label htmlFor="sequence">Sequence No</label>
                                        <input
                                            value={video.video_sequence_no}
                                            onChange={(e) => setVideoDetailsArray(prevDetails => {
                                                const updatedDetails = [...prevDetails];
                                                updatedDetails[index].video_sequence_no = e.target.value;
                                                return updatedDetails;
                                            })}
                                            type="number"
                                            min="1"
                                            className='dateinput w-full h-12 border rounded-lg'
                                            style={{ border: '1px solid #384D6C' }}
                                        />
                                    </div>

                                </div>
                                

                                     {/* row2 */}
                                     <div className='flex flex-row justify-between flex-wrap'>
                                    <div className='mt-6 flex flex-col md:w-5/12 w-full'>
                                        <label htmlFor="title">Title</label>
                                        <input
                                            value={video.video_title}
                                            onChange={(e) => setVideoDetailsArray(prevDetails => {
                                                const updatedDetails = [...prevDetails];
                                                updatedDetails[index].video_title = e.target.value;
                                                return updatedDetails;
                                            })}
                                            type="text"
                                            className='dateinput w-full h-12 rounded-lg'
                                            style={{ border: '1px solid #384D6C' }} 

                                        />
                                    </div>
                                    <div className='mt-6 flex flex-col md:w-5/12 w-full'>
                                        <label htmlFor="subject">Subject</label>
                                        <input
                                            value={video.video_subject}
                                            onChange={(e) => setVideoDetailsArray(prevDetails => {
                                                const updatedDetails = [...prevDetails];
                                                updatedDetails[index].video_subject = e.target.value;
                                                return updatedDetails;
                                            })}
                                            type="text"
                                            className='dateinput w-full h-12 rounded-lg'
                                            style={{ border: '1px solid #384D6C' }} 

                                        />
                                    </div>
                                </div>


                                 {/* row3 */}
                                <div className='flex flex-row justify-between flex-wrap'>
                                    <div className='mt-6 flex flex-col md:w-5/12 w-full'>
                                        <label htmlFor="event">Event</label>
                                        <Select
                                            id='event'
                                            styles={{
                                                control: (baseStyles, state) => ({
                                                    ...baseStyles,
                                                    borderColor: state.isFocused ? '#384D6C' : '#384D6C',
                                                    height: '3rem',
                                                    borderRadius: '0.5rem',
        
                                                }),
                                            }}
                                            options={eventoptions}
                                            value={eventoptions.find(option => option.value === video.video_event)}
                                            onChange={option => setVideoDetailsArray(prevDetails => {
                                                const updatedDetails = [...prevDetails];
                                                updatedDetails[index].video_event = option.value;
                                                return updatedDetails;
                                            })}
                                        />
                                    </div>
                                    <div className='mt-6 flex flex-col md:w-5/12 w-full'>
                                        <label htmlFor="member">Member</label>
                                        <Select
                                            id='member'
                                            options={memberoptions}
                                            isMulti
                                            value={memberoptions.filter(option => video.video_member.includes(option.value))}
                                            onChange={option => setVideoDetailsArray(prevDetails => {
                                                const updatedDetails = [...prevDetails];
                                                updatedDetails[index].video_member = option ? option.map(item => item.value) : [];
                                                return updatedDetails;
                                            })}
                                            styles={{
                                                control: (baseStyles, state) => ({
                                                    ...baseStyles,
                                                    borderColor: state.isFocused ? '#384D6C' : '#384D6C',
                                                    height: '3rem',
                                                    borderRadius: '0.5rem',
        
                                                }),
                                            }}
                                        />
                                    </div>
                                </div>

                                {/* row4 */}
                                <div className='flex flex-row justify-between flex-wrap'>
                                    <div className='mt-6 flex flex-col md:w-5/12 w-full'>
                                        <label htmlFor="url">Kla</label>
                                        <div
                                            
                                            className='dateinput w-fll h-12 rounded-lg p-2'
                                            style={{ border: '1px solid #384D6C' }} 
                                            min="1"
                                        >
                                            {VideoInitialDetails?.kla?.label}
                                            </div>
                                    </div>

                                    <div className='mt-6 flex flex-col md:w-5/12 w-full'>
                                        <label htmlFor="sequence">Session</label>
                                        <div
                                            
                                            min="1"
                                            className='dateinput w-full h-12 border rounded-lg p-2'
                                            style={{ border: '1px solid #384D6C' }}
                                        >
                                            {VideoInitialDetails.video_session.label}
                                            </div>
                                    </div>

                                </div>

                                  {/* row4 */}
                                  <div className='flex flex-row justify-between flex-wrap'>
                                    <div className='mt-6 mb-6 flex flex-col md:w-5/12 w-full'>
                                        <label htmlFor="url">Date</label>
                                        <div
                                            type="text"
                                            className='dateinput w-fll h-12 rounded-lg p-2'
                                            style={{ border: '1px solid #384D6C' }} 
                                            min="1"
                                        >
                                            {VideoInitialDetails.video_upload_date}
                                            </div>
                                    </div>

                                    {/* <div className='mt-6 flex flex-col md:w-5/12 w-full'>
                                        <label htmlFor="sequence">Date</label>
                                        <div
                                            value={video.video_upload_date}
                                            
                                            type="number"
                                            min="1"
                                            className='dateinput w-full h-12 border rounded-lg p-2'
                                            style={{ border: '1px solid #384D6C' }}
                                        >
                                            {VideoInitialDetails.video_upload_date}
                                            </div>
                                    </div> */}

                                </div>
                                




                                {/* <div className='flex flex-row justify-between flex-wrap'>
                                <div className='mt-6 flex flex-col md:w-5/12 w-full'>
                                    <label htmlFor="tags">Tags</label>
                                    <div className="flex flex-row">
                                        <input
                                            value={keyFromInput}
                                            onChange={(e) => setKeyFromInput(e.target.value)}
                                            type="text"
                                            placeholder="Key"
                                            className='dateinput w-32 h-12 rounded-lg'
                                            style={{ border: '1px solid #384D6C' }} 

                                        />
                                        <input
                                            value={valueFromInput}
                                            onChange={(e) => setValueFromInput(e.target.value)}
                                            type="text"
                                            placeholder="Value"
                                            className='dateinput ml-2 w-32 h-12 rounded-lg'
                                            style={{ border: '1px solid #384D6C' }} 
                                        />
                                        <button onClick={() => handleTagAdd(index)} className='ml-2 focus:outline-none bg-black text-white font-bold py-2 px-2 rounded-lg'>Add</button>
                                    </div>
                                    <div className='mt-2'>
                                        {Object.entries(video.video_tags).map(([tagName, tag], i) => (
                                            <div key={i} className="flex justify-between border border-gray-300 px-4 py-1 mb-2 rounded-lg">
                                                <span>{`${tag.key}: ${tag.value}`}</span>
                                                <button onClick={() => handleRemoveTag(index, tagName)} className="focus:outline-none text-red-500">Remove</button>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div> */}

                                {/* <div className='flex justify-center'>
                                    <button onClick={handleSave} className='focus:outline-none bg-black text-white font-bold py-2 px-6 rounded-lg mt-6 mr-4'>Save</button>
                                    <button onClick={handleCancel} className='focus:outline-none bg-gray-500 text-white font-bold py-2 px-6 rounded-lg mt-6'>Cancel</button>
                                </div> */}

                            </div>
                        </div>
                    ))}
                     <div className='flex justify-center mb-10 w-full'>
                                    <button onClick={handleSave} className='w-3/12 focus:outline-none bg-black text-white font-bold py-2 px-6 rounded-lg mt-6 mr-4'>Save</button>
                                    <button onClick={handleCancel} className='focus:outline-none bg-gray-500 text-white font-bold py-2 px-6 rounded-lg mt-6'>Cancel</button>
                                </div>
                   </div>
                </>
            }
            <ToastContainer />
        </>
    );
}

export default AddVideo;
